import React, { useEffect } from 'react';
import { TourCard } from '../components/TourCard';
import { pilgrimTours } from '../mockData';
import { Heart, CheckCircle } from 'lucide-react';

export const PilgrimTours = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pilgrim-tours-page">
      {/* Hero Section */}
      <section className="relative h-[300px] flex items-center justify-center">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1548013146-72479768bada)'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-sky-900/80 to-emerald-900/80"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-4 text-center text-white">
          <Heart className="w-16 h-16 mx-auto mb-4" />
          <h1 className="text-5xl font-bold mb-4">Pilgrim Tours</h1>
          <p className="text-xl">Embark on a spiritual journey with comfort and peace</p>
        </div>
      </section>

      {/* Tours Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Sacred Journeys Across India</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Experience divine blessings with our thoughtfully planned pilgrimage tours. We ensure your spiritual 
              journey is comfortable, hassle-free, and deeply meaningful.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {pilgrimTours.map((tour) => (
              <TourCard key={tour.id} tour={tour} />
            ))}
          </div>
          
          <div className="mt-12 bg-gradient-to-r from-orange-50 to-yellow-50 p-8 rounded-lg max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Our Pilgrim Tour Services</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
              <div className="flex items-start space-x-2">
                <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" />
                <span>VIP darshan arrangements</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" />
                <span>Comfortable accommodation</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" />
                <span>Experienced tour guides</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" />
                <span>All meals included (Satvik food)</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" />
                <span>Helicopter services (where applicable)</span>
              </div>
              <div className="flex items-start space-x-2">
                <CheckCircle className="w-5 h-5 text-orange-600 flex-shrink-0 mt-1" />
                <span>Medical assistance on standby</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};